import { FormattedMessage } from 'react-intl';
import { translationExists } from 'myParkdUtils/utils';
import { TelematicProviderTypeMetadata, TelematicProviderType, DeviceImportRequest } from 'types';


export const getTelematicDisplayName = (telematicProviderType: TelematicProviderType, telematicProviderTypeMetadata: TelematicProviderTypeMetadata[]): string =>
    telematicProviderTypeMetadata
        .find(metadata => metadata.providerType === telematicProviderType)
        ?.displayName ?? telematicProviderType;


type Props = {
    importRequests: DeviceImportRequest[],
    telematicTypesMetadata: TelematicProviderTypeMetadata[]
}

const TableInvalidLicensePlates = (props: Props) => {
    return (
        <table className="tbl-import-requests-validation tbl-invalid">
            <tbody>
                {props.importRequests.map((request: any, i: number) => (
                    <tr key={i}>
                        <td>{request.request.licensePlate}</td>
                        <td>
                            <ul className="bullet-list">
                                {!!request.validations.length &&
                                    request.validations.map((validation: any, i: number) => {
                                        let validationReasonMessageId = 'LP_IMPORT_' + String(validation.reason);
                                        let telematicProviderType = validation?.info?.type || '';
                                        let telematicDisplayName = telematicProviderType ? getTelematicDisplayName(telematicProviderType, props.telematicTypesMetadata) : telematicProviderType;

                                        return (
                                            <li key={i}>
                                                {translationExists(validationReasonMessageId) ? (
                                                    <FormattedMessage
                                                        id={validationReasonMessageId}
                                                        values={{ telematicType: telematicDisplayName }}
                                                    />
                                                ) : (
                                                    <span>{validation.reason}</span>
                                                )}
                                            </li>
                                        );
                                    })}
                            </ul>
                        </td>
                    </tr>
                ))}
            </tbody>
        </table>
    );
};

export default TableInvalidLicensePlates;